export default __webpack_public_path__ + "static/media/P8.f83bceb2.png";